import { SampleSendType } from "utils/constant";

// Peta field kondisi per jenis sampel (dipakai untuk Step 2).
const CONDITION_FIELDS = {
  [SampleSendType.SAD]: "sample_sad_condition",
  [SampleSendType.DBS]: "sample_dbs_condition",
  [SampleSendType.WB]: "sample_wb_condition",
};

// Jenis sampel yang dikirim dibaca dari sample_send_type, bukan dari tanggal
// kirim. Dua kasus dibedakan:
// - tidak ada jenis sama sekali (NULL/undefined/""/[]/[nilai kosong]): data lama,
//   dianggap SAD saja karena sebelum migrasi sample_send_type SAD wajib dikirim;
// - ada jenis tapi tak dikenal: jangan fallback ke SAD (fail-closed, searah
//   dengan halaman Lab 3/4), supaya blok dan gate PCR tidak salah.
export const sentSampleTypes = (row = {}) => {
  const raw = Array.isArray(row?.sample_send_type)
    ? row.sample_send_type.filter(Boolean)
    : [];
  const known = raw.filter((type) => CONDITION_FIELDS[type]);
  if (known.length > 0) return known;
  return raw.length > 0 ? [] : [SampleSendType.SAD];
};

export const hasSentType = (sample, type) =>
  sentSampleTypes(sample).includes(type);

// Step 2 (PCR) dibutuhkan bila ada jenis sampel yang ditampilkan dengan kondisi
// "Ya". Jenis yang tidak dikirim tidak dihitung walau kondisinya terisi.
export const isPcrNeeded = (row = {}) =>
  sentSampleTypes(row).some((type) => row?.[CONDITION_FIELDS[type]] === "Ya");

const hasPcrResult = (row = {}) =>
  Array.isArray(row?.pcr_checking_result)
    ? row.pcr_checking_result.length > 0
    : Boolean(row?.pcr_checking_result);

// Step 1 selesai bila tanggal terima terisi dan kondisi SEMUA jenis sampel yang
// dikirim terisi. Jenis tak dikenal (daftar kosong) dianggap belum selesai.
export const isStep1Complete = (row = {}) => {
  if (!row?.sample_received_date) return false;
  const types = sentSampleTypes(row);
  if (types.length === 0) return false;
  return types.every((type) => Boolean(row?.[CONDITION_FIELDS[type]]));
};

// Final bila Step 1 selesai dan (PCR tidak diperlukan atau PCR sudah lengkap).
export const isComplete = (row = {}) =>
  isStep1Complete(row) &&
  (!isPcrNeeded(row) ||
    (Boolean(row?.pcr_finish_checking_date) && hasPcrResult(row)));

// State kolom Aksi: terkunci (label saja) hanya bila Step 2 PCR benar-benar aktif
// dan selesai; saat PCR tidak diperlukan baris tetap bisa diedit seperti Lab 3/4.
export const actionState = (row = {}) => {
  if (!isStep1Complete(row)) return "edit";
  return isComplete(row) && isPcrNeeded(row) ? "checked" : "edit-checked";
};
